export default [
  {
    path: '/tasks',
    name: 'tasks',
    component: () => import('@/views/tasks/TasksMain.vue'),
  },
  {
    path: '/tasks/create',
    name: 'tasks-create',
    component: () => import('@/views/tasks/TasksCreate.vue'),
  },
];
